import { Text, TextProps } from "@chakra-ui/react";
import React, { ReactElement } from "react";

export type ParaProps = TextProps;

export default function Para(props: ParaProps): ReactElement {
  return <Text my="8" {...props} />;
}
